var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    [
      _c("UploadDialog", {
        ref: "dialog",
        attrs: {
          "payload-only": _vm.payloadOnly,
          "return-file-only": _vm.returnFileOnly,
          multiple: _vm.multiple,
          "file-type": _vm.fileType,
          value: _vm.files,
        },
        on: { change: _vm.updateFiles },
      }),
      _c(
        "v-col",
        {
          class: _vm.isReversed ? "d-flex flex-column-reverse" : "",
          attrs: { cols: "auto" },
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.label === undefined || _vm.label === null
                          ? "Медиа-файлы"
                          : _vm.label
                      )
                    ),
                  ]),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: { "x-small": "", color: "primary", outlined: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$refs.dialog.open()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.buttonName || "Загрузить...") + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.files, function (fileId) {
            return _c("MediaFilePreview", {
              key: fileId,
              attrs: {
                description: "",
                "is-chosen": "",
                "hide-delete": _vm.hideDelete,
                value: fileId,
                caption: _vm.caption,
              },
              on: { change: _vm.updateFiles },
            })
          }),
          _vm._t("preview-bottom"),
          _vm.isShowCaption
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c("span", [_vm._v("Заголовок")]),
                      _c("v-text-field", {
                        staticClass: "mt-0 pt-0",
                        attrs: { outlined: "", dense: "", value: _vm.caption },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change-caption", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }